import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import WizardButtonList from '../WizardButtonList';
import WizardNavigation from '../WizardNavigation';
import Aux from '../../../hoc/Aux';
import WizardStandardHeader from '../WizardStandardHeader';
import WizardStandardSubHeader from '../WizardStandardSubHeader';
import { axiosProtected } from '../../../axios-wizard';
import { useTranslation } from 'react-i18next';
import * as actions from '../../../store/actions/index';
import useWindowDimensions from '../../../hooks/useWindowDimensions';

const wizardStepMediumType = (props) => {

  const getButtonsUrl = '/api/step_combinations/installation_location?country=' + props.selectedSteps.country + '&fwk=' + props.selectedSteps.fwk
  const onSelectAction = (stepValue) => { return actions.wizardSelectLocation(stepValue) }

  if (props.currentStep !== 'location') {
    return null;
  }

  const { t } = useTranslation();

  const [buttons, setButtons] = useState([]);

  const { width } = useWindowDimensions();

  const dispatch = useDispatch();
  const onSelect = useCallback(
      (stepValue) => dispatch(onSelectAction(stepValue)),
      [dispatch]
    )



  const classRowButtons = () => (width > 1320)? "row" : "row installation-locations";


  useEffect(() => {
      const fetchData = async () => {
        const result = await axiosProtected(
          getButtonsUrl,
        );
        setButtons(result.data);
      };
      fetchData();
    }, []);

  const sortCustom = (arrayToSort, customOrder) => {
    let ordering = {};

    for (let i=0; i<customOrder.length; i++) {
      ordering[customOrder[i]] = i;
    }

    return arrayToSort.sort( function(a, b) {
        return (ordering[a] - ordering[b]);
    });

  }

  // wm => 100
  // hw1 => 100
  // hw2 => 120
  const sortOrderWand = ['wm150', 'hw2', 'wm', 'wl', 'hw1', 'wl75'];
  const filteredButtonsWand = buttons.filter(value => sortOrderWand.includes(value));
  const buttonsWand = sortCustom(filteredButtonsWand, sortOrderWand);

  // sl => 90
  // sm => 70
  const sortOrderSchachtwand = ['sl95', 'sl', 'sl80', 'sm'];
  const filteredButtonsSchachtwand = buttons.filter(value => sortOrderSchachtwand.includes(value));
  const buttonsSchachtwand = sortCustom(filteredButtonsSchachtwand, sortOrderSchachtwand);

  // d => 150
  const sortOrderDecke = ['d200', 'd', 'hd150', 'hd120'];
  const filteredButtonsDecke = buttons.filter(value => sortOrderDecke.includes(value));
  const buttonsDecke = sortCustom(filteredButtonsDecke, sortOrderDecke);
2
  return(
    <Aux>

      <WizardStandardHeader>
        <WizardNavigation />
      </WizardStandardHeader>

      <div className="row justify-content-center content-list-head">
        <div className="col-lg-11 col-xl-11">
          <WizardStandardSubHeader
            display={true}
            modalTitle={ t('wizard.steps.location.modaltitle') }
            title={t('wizard.steps.location.title')}
            modalTextToken={ 'wizard.steps.location.infotext' } />
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-lg-11 col-xl-11">

          {(buttonsWand.length > 0)?
            <Aux>
              <div className="row">
                <div className="col-12 col-md-11 pt-3"><h3 style={{marginBottom: "0px", fontSize: "1.2rem", color: "#212529c7"}}>{ t('wizard.steps.location.group.wand') }</h3></div>
              </div>
              <div className={classRowButtons()}>
                <WizardButtonList
                  buttons={buttonsWand}
                  stepName={'location'}
                  onClick={onSelect}
                  withSubtitle={true}
                  dividerEnabled={true}
                  />
              </div>
            </Aux> : null}

          {(buttonsSchachtwand.length > 0)?
            <Aux>
              <div className="row">
                <div className="col-12 col-md-11 pt-3"><h3 style={{marginBottom: "0px", fontSize: "1.2rem", color: "#212529c7"}}>{ t('wizard.steps.location.group.schachtwand') }</h3></div>
              </div>
              <div className={classRowButtons()}>
                <WizardButtonList
                  buttons={buttonsSchachtwand}
                  stepName={'location'}
                  onClick={onSelect}
                  withSubtitle={true}
                  dividerEnabled={true}
                  />
              </div>
            </Aux> : null}

          {(buttonsDecke.length > 0)?
            <Aux>
              <div className="row">
                <div className="col-12 col-md-11 pt-3"><h3 style={{marginBottom: "0px", fontSize: "1.2rem", color: "#212529c7"}}>{ t('wizard.steps.location.group.decke') }</h3></div>
              </div>
              <div className={classRowButtons()}>
                <WizardButtonList
                  buttons={buttonsDecke}
                  stepName={'location'}
                  onClick={onSelect}
                  withSubtitle={true}
                  dividerEnabled={true}
                  />
              </div>
            </Aux> : null}

        </div>
      </div>

    </Aux>
 );
};

export default wizardStepMediumType;



// WEBPACK FOOTER //
// ./src/components/Wizard/Steps/WizardStepLocation.js